import React from 'react';
import '../style/DateTimeRange.scss';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import MonthYearSelector from './MonthYearSelector';
import CalendarHeader from './CalendarHeader';
import CalendarRows from './CalendarRows';
import { createYears } from '../utils/YearUtils';
import { getMonth, getYear, getFourtyTwoDays } from '../utils/TimeFunctionUtils';

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    const initialMonth = getMonth(
      props.date,
      props.otherDate,
      props.mode,
      props.pastSearchFriendly,
      props.smartMode
    );
    const initialYear = getYear(
      props.date,
      props.otherDate,
      props.mode,
      props.pastSearchFriendly,
      props.smartMode
    );

    this.state = {
      month: initialMonth,
      year: initialYear,
    };

    this.changeMonthCallback = this.changeMonthCallback.bind(this);
    this.changeYearCallback = this.changeYearCallback.bind(this);
    this.changeMonthArrowsCallback = this.changeMonthArrowsCallback.bind(this);
  }

  componentDidMount() {
    this.updateMonthYear();
  }

  componentDidUpdate(previousProps) {
    const isDifferentMomentObject = !previousProps.date.isSame(this.props.date) || !previousProps.otherDate.isSame(this.props.otherDate);
    const isDifferentTime = this.props.date.format('DD-MM-YYYY HH:mm') !== previousProps.date.format('DD-MM-YYYY HH:mm') || this.props.otherDate.format('DD-MM-YYYY HH:mm') !== previousProps.otherDate.format('DD-MM-YYYY HH:mm');
    if (isDifferentMomentObject || isDifferentTime) {
      this.updateMonthYear();
    }
  }

  updateMonthYear() {
    const newMonth = getMonth(
      this.props.date,
      this.props.otherDate,
      this.props.mode,
      this.props.pastSearchFriendly,
      this.props.smartMode,
    );
    const newYear = getYear(
      this.props.date,
      this.props.otherDate,
      this.props.mode,
      this.props.pastSearchFriendly,
      this.props.smartMode,
    );
    this.setState({
      month: newMonth,
      year: newYear,
    });
  }

  createMonths(local) {
    if (local && local.months) {
      return local.months;
    }
    return [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
  }

  changeMonthCallback(event) {
    this.setState({ month: parseInt(event.target.value, 10) });
  }

  changeMonthArrowsCallback(isPreviousChange, isNextChange) {
    const years = createYears(this.props.years, this.props.descendingYears);
    let { month, year } = this.state;

    let newMonthYear;
    if (isPreviousChange) {
      newMonthYear = this.getPreviousMonth(month, year, years);
    }
    if (isNextChange) {
      newMonthYear = this.getNextMonth(month, year, years);
    }

    this.setState({
      year: newMonthYear.year,
      month: newMonthYear.month,
    });
  }

  getPreviousMonth(month, year, years) {
    const isStartOfMonth = month === 0;
    const isFirstYear = parseInt(year) === years[0];

    if (!(isStartOfMonth && isFirstYear)) {
      if (month === 0) {
        month = 11;
        year -= 1;
      } else {
        month -= 1;
      }
    }
    return { month, year };
  }

  getNextMonth(month, year, years) {
    const isEndOfMonth = month === 11;
    const isLastYear = parseInt(year) === years[years.length - 1];
    if (!(isEndOfMonth && isLastYear)) {
      if (month === 11) {
        month = 0;
        year += 1;
      } else {
        month += 1;
      }
    }
    return { month, year };
  }

  changeYearCallback(event) {
    this.setState({ year: parseInt(event.target.value, 10) });
  }

  render() {
    const { local, mode, darkMode } = this.props;
    const { month, year } = this.state;
    const months = this.createMonths(local);
    const years = createYears(this.props.years, this.props.descendingYears);
    let headers = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
    let sundayFirst = false;
    if (local) {
      if (local.days) {
        headers = local.days;
      }
      if (local.sundayFirst) {
        sundayFirst = true;
        headers.unshift(headers.pop());
      }
    }

    const fourtyTwoDays = getFourtyTwoDays(month, year, sundayFirst);
    return (
      <div>
        <MonthYearSelector
          months={months}
          years={years}
          month={month}
          year={year}
          mode={mode}
          changeMonthCallback={this.changeMonthCallback}
          changeYearCallback={this.changeYearCallback}
          changeMonthArrowsCallback={this.changeMonthArrowsCallback}
          darkMode={darkMode}
        />
        <CalendarHeader headers={headers} />
        <CalendarRows
          fourtyTwoDays={fourtyTwoDays}
          date={this.props.date}
          mode={this.props.mode}
          otherDate={this.props.otherDate}
          maxDate={this.props.maxDate}
          month={month}
          year={year}
          dateSelectedNoTimeCallback={this.props.dateSelectedNoTimeCallback}
          keyboardCellCallback={this.props.keyboardCellCallback}
          focusOnCallback={this.props.focusOnCallback}
          focusDate={this.props.focusDate}
          cellFocusedCallback={this.props.cellFocusedCallback}
          smartMode={this.props.smartMode}
          style={this.props.style}
          darkMode={darkMode}
        />
      </div>
    );
  }
}

Calendar.propTypes = {
  date: momentPropTypes.momentObj,
  mode: PropTypes.string.isRequired,
  otherDate: momentPropTypes.momentObj,
  maxDate: momentPropTypes.momentObj,
  dateSelectedNoTimeCallback: PropTypes.func.isRequired,
  keyboardCellCallback: PropTypes.func.isRequired,
  focusOnCallback: PropTypes.func.isRequired,
  focusDate: PropTypes.any.isRequired,
  descendingYears: PropTypes.bool,
  years: PropTypes.array,
  pastSearchFriendly: PropTypes.bool,
  smartMode: PropTypes.bool,
  cellFocusedCallback: PropTypes.func.isRequired,
  local: PropTypes.object,
  style: PropTypes.object,
  darkMode: PropTypes.bool,
};
export default Calendar;
